export const legacyNewUiRedirectPaths = [
  { path: 'settings-old', to: '/settings' },
  { path: 'company-old', to: '/company' }
] as const
